<template>
  <div>
    <v-dialog
      v-model="activo"
      max-width="200px"
      scrollable
    >
      <v-card
        flat
      >
        <v-card-title class="pa-0">
          <v-toolbar elevation="0" color="red darken-1" height="50%" flat dark>
            <v-toolbar-title>
              <v-icon>mdi-translate</v-icon> {{ $t('idiomas') }}
            </v-toolbar-title>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-row :no-gutters="$vuetify.breakpoint.xs">
            <v-col cols="12" class="pa-0">
              <v-chip-group 
                v-for="entry in languages" 
                :key="entry.title"
                column
              >
                <v-chip class="ma-2" pill @click="changeLocale(entry)">
                  <v-avatar>
                    <flag :iso="entry.flag" v-bind:squared=false />
                  </v-avatar>
                  <span class="mx-2">
                    {{ entry.title }}
                  </span>
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    datos: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    activo: {
      get(){
        return this.datos.activo
      },
      set(value){
        this.$emit('setearModalIdiomas', value)
      }
    },
    languages: {
      get(){
        return this.datos.languages
      }
    }
  },
  methods: {
    changeLocale(value){
      this.$emit('setearLanguaje', value)
      this.activo = false
    }
  },
}
</script>

<style>
  .v-slide-group__content{
    justify-content: center !important;
  }
</style>